var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRiskAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.67502V6.31085M9 12.1686V12.1981M13.2524 15H4.74755C3.58583 15 2.60544 14.2322 2.29699 13.1818C2.16532 12.7334 2.32711 12.2663 2.57457 11.8687L6.82702 4.20077C7.82332 2.59974 10.1767 2.59974 11.173 4.20077L15.4254 11.8687C15.6729 12.2663 15.8347 12.7334 15.703 13.1818C15.3946 14.2322 14.4142 15 13.2524 15Z",
    stroke: "#D7DFE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRiskAssessment);
export default __webpack_public_path__ + "static/media/IconRiskAssessment.7ea7604f2a73d6eca7cee6cb6be3c69a.svg";
export { ForwardRef as ReactComponent };